/**
 * Wholesale Tile Types API Client
 */

import apiClient from '../client';

const BASE_URL = '/wholesale/tile-types';

// ===== GET ALL =====

/**
 * Get all tile types with optional filters
 */
export const getTileTypes = async (filters = {}) => {
  try {
    const response = await apiClient.get(BASE_URL, { params: filters });
    return response.data?.data || response.data || [];
  } catch (error) {
    console.error('Error fetching tile types:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch tile types',
      status: error.response?.status,
    };
  }
};

/**
 * Get tile types grouped by size category
 */
export const getTileTypesGrouped = async (companyId = null) => {
  try {
    const params = companyId ? { company_id: companyId } : {};
    const response = await apiClient.get(`${BASE_URL}/grouped`, { params });
    return response.data?.data || response.data || {};
  } catch (error) {
    console.error('Error fetching grouped tile types:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch grouped tile types',
      status: error.response?.status,
    };
  }
};

// ===== GET BY ID =====

/**
 * Get tile type by ID
 */
export const getTileTypeById = async (id) => {
  try {
    const response = await apiClient.get(`${BASE_URL}/${id}`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error fetching tile type:', error);
    throw {
      message: error.response?.data?.error || 'Failed to fetch tile type',
      status: error.response?.status,
    };
  }
};

// ===== CREATE =====

/**
 * Create a new tile type
 */
export const createTileType = async (data) => {
  try {
    const response = await apiClient.post(BASE_URL, data);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error creating tile type:', error);
    throw {
      message: error.response?.data?.error || 'Failed to create tile type',
      status: error.response?.status,
    };
  }
};

// ===== UPDATE =====

/**
 * Update a tile type
 */
export const updateTileType = async (id, data) => {
  try {
    const response = await apiClient.patch(`${BASE_URL}/${id}`, data);
    return response.data?.data || response.data;
  } catch (error) {
    console.error('Error updating tile type:', error);
    throw {
      message: error.response?.data?.error || 'Failed to update tile type',
      status: error.response?.status,
    };
  }
};

// ===== DELETE =====

/**
 * Delete a tile type
 */
export const deleteTileType = async (id) => {
  try {
    const response = await apiClient.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting tile type:', error);
    throw {
      message: error.response?.data?.error || 'Failed to delete tile type',
      status: error.response?.status,
    };
  }
};

export default {
  getTileTypes,
  getTileTypesGrouped,
  getTileTypeById,
  createTileType,
  updateTileType,
  deleteTileType,
};
